<template>
    <b-modal id="device-settings" centered hide-header hide-footer body-class="p-0" ref="settings-modal">
        <div class="modal-header bg-primary d-flex justify-content-between">
            <div class="device-modal d-flex flex-row align-items-center">
                <img :src="require(`@/assets/img/devices/${icon}.png`)" />
                <p class="text-light m-0 fs-4 ms-2">{{ plate }}</p>
            </div>
            <div class="close-modal d-flex" @click="close">
                <img src="@/assets/img/close.svg" />
            </div>
        </div>
        <div class="d-flex flex-column p-3">
            <div class="item-setting d-flex flex-row align-items-end">
                <b-form-group class="p-1" id="input-group-1" label="Velocidad Máxima:" label-for="speed-limit">
                    <b-form-input id="speed-limit" v-model="speedLimit" type="number"></b-form-input>
                </b-form-group>
                <p class="m-0">Km/h</p>
            </div>
            <div class="item-setting d-flex flex-row align-items-end">
                <b-form-group class="p-1" id="input-group-2" label="Combustible:" label-for="fuel-type">
                    <b-form-select id="fuel-type" v-model="fuel_type" :options="fuels" required></b-form-select>
                </b-form-group>
            </div>
            <div class="item-setting d-flex flex-row align-items-end">
                <b-form-group class="p-1" id="input-group-3" label="Rendimiento:" label-for="fuel_efficiency">
                    <b-form-input id="fuel_efficiency" v-model="fuel_efficiency" type="number"></b-form-input>
                </b-form-group>
                <p class="m-0">Km/{{ unit }}</p>
            </div>
            <div class="item-setting d-flex flex-row align-items-end">
                <b-form-group class="p-1" id="input-group-4" label="Costo del Combustible:" label-for="fuel-cost">
                    <b-form-input id="fuel-cost" v-model="fuel_cost" type="number"></b-form-input>
                </b-form-group>
                <p class="m-0">{{ money }}/{{ unit }}</p>
            </div>
            <b-button type="submit" variant="primary" class="mt-3" @click="saveSettings">Guardar</b-button>
        </div>
    </b-modal>
</template>
<script lang="ts">
import DeviceService from '@/api/services/device.service'
import { FuelTypeMoneyEnum } from '@/models/enum-types/fuel-type-money.enum'
import { FuelTypeUnitEnum } from '@/models/enum-types/fuel-type-unit.enum'
import { Component, Vue, Watch } from 'vue-property-decorator'
@Component({})
export default class DeviceSettings extends Vue {
    deviceId = 0
    plate = 'D7k-138'
    icon = '0'
    speedLimit = '12.34'
    fuel_type = 'GNV'
    unit = 'm3'
    fuel_efficiency = 12.5
    fuel_cost = 12.54
    money = 'Soles'

    fuels = Object.keys(FuelTypeUnitEnum)

    @Watch('fuel_type', { immediate: true })
    onChangeFuelType(type: string): void {
        this.unit = Object(FuelTypeUnitEnum)[type]
        this.money = Object(FuelTypeMoneyEnum)[type]
    }

    close() {
        const modal: any = this.$refs['settings-modal']
        modal.hide()
    }

    show() {
        const modal: any = this.$refs['settings-modal']
        modal.show()
    }

    async saveSettings() {
        await DeviceService.setDevice(
            this.deviceId,
            {
                fuelCost: this.fuel_cost,
                fuelEfficiency: this.fuel_efficiency,
                fuelType: this.fuel_type,
            },
            Number(this.speedLimit)
        )

        this.close()
    }
}
</script>
<style lang="sass">
.item-setting
    p
        margin-bottom: 10px !important
        font-size: 18px
.modal-header
    height: 60px !important
    img
        height: 45px

.close-modal
    height: 20px
    cursor: pointer
    transition: all .1s ease
    &:active
        transform: scale(0.9)

    img
        height: 100%
</style>
